import React, { useEffect, useState } from "react";
import { apiFetch } from "../utils/api";
import "./TravelGuides.css";

function TravelGuides() {
  const [articles, setArticles] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchArticles = async () => {
      try {
        const data = await apiFetch("/api/magic-article");
        setArticles(data.articles || []);
      } catch (error) {
        console.error("Failed to fetch articles:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchArticles();
  }, []);

  return (
    <div>
      {/* Hero */}
      <div className="container-fluid bg-primary py-5 mb-5 hero-header">
        <div className="container py-5">
          <div className="row justify-content-center py-5">
            <div className="col-lg-10 pt-lg-5 mt-lg-5 text-center">
              <h1 className="display-3 text-white animated slideInDown">
                Guides
              </h1>
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb justify-content-center">
                  <li className="breadcrumb-item">
                    <a href="/">Home</a>
                  </li>
                  <li
                    className="breadcrumb-item text-white active"
                    aria-current="page"
                  >
                    Travel Guides
                  </li>
                </ol>
              </nav>
            </div>
          </div>
        </div>
      </div>

      {/* Content */}
      <div className="container-xxl py-5">
        <div className="container">
          <div className="text-center wow fadeInUp" data-wow-delay="0.1s">
            <h6 className="section-title bg-white text-center text-primary px-3">
              Outpost Travel Guides
            </h6>
            <h1 className="mb-5">Awesome Destinations</h1>
          </div>

          {loading ? (
            <p className="text-center">Loading guides...</p>
          ) : (
            <div className="row g-4 justify-content-center">
              {articles.map((article) => (
                <div
                  key={article.id}
                  className="col-lg-4 col-md-6 wow fadeInUp"
                  data-wow-delay="0.1s"
                >
                  <div className="package-item h-100 d-flex flex-column">
                    {/* Image */}
                    <div className="guide-image">
                      <img
                        src={article.ImageUrl || "/img/placeholder.jpg"}
                        alt={article.ImageAlt || article.Name}
                      />
                    </div>

                    {/* Content */}
                    <div className="text-center p-4 d-flex flex-column flex-grow-1">
                      <h3 className="mb-3 guide-title">
                        {article.Name}
                      </h3>

                      <p className="guide-abstract">
                        {article.Abstract}
                      </p>

                      {/* Footer */}
                      <div className="mt-auto">
                        <div className="d-flex justify-content-center mb-2">
                          <a
                            href={article.SourceUrl}
                            className="btn btn-sm btn-primary px-3 border-end"
                            style={{ borderRadius: "30px 0 0 30px" }}
                            target="_blank"
                            rel="noreferrer"
                          >
                            Read More
                          </a>
                          <a
                            href="/register"
                            className="btn btn-sm btn-primary px-3"
                            style={{ borderRadius: "0 30px 30px 0" }}
                          >
                            Book Now
                          </a>
                        </div>

                        {article.DateTime && (
                          <small className="text-muted d-block mt-2">
                            {new Date(article.DateTime).toLocaleDateString()}
                          </small>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default TravelGuides;
